import React, { useState, useEffect} from "react";


import { useForm, Controller } from "react-hook-form";
import { format } from "date-fns";
import axios from "axios";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Tooltip,
  Snackbar,
  Alert,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import Layout from "../components/layout/GSTlayout";
import config from "../config.js";
import { useSelector } from 'react-redux';

const TaskForm = ({ open, onClose, currentTask, onSubmit }) => {
  
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      clientName: currentTask?.clientName || "",
      taskType: currentTask?.taskType || "",
      dueDate: currentTask?.dueDate
        ? format(new Date(currentTask.dueDate), "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd"),
      status: currentTask?.status || "Pending",
      priority: currentTask?.priority || "Medium",
      description: currentTask?.description || "",
    },
  });

  useEffect(() => {
    if (currentTask) {
      reset({
        clientName: currentTask.clientName,
        taskType: currentTask.taskType,
        dueDate: format(new Date(currentTask.dueDate), "yyyy-MM-dd"),
        status: currentTask.status,
        priority: currentTask.priority,
        description: currentTask.description,
      });
    } else {
      reset({
        clientName: "",
        taskType: "",
        dueDate: format(new Date(), "yyyy-MM-dd"),
        status: "Pending",
        priority: "Medium",
        description: "",
      });
    }
  }, [currentTask, reset]);

  const handleFormSubmit = async (data) => {
    await onSubmit(data);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogTitle>
          {currentTask?._id ? "Edit Task" : "Add New Task"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <Controller
                name="clientName"
                control={control}
                rules={{ required: "Client name is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Client Name"
                    error={!!errors.clientName}
                    helperText={errors.clientName?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="taskType"
                control={control}
                rules={{ required: "Task type is required" }}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.taskType}>
                    <InputLabel>Task Type</InputLabel>
                    <Select {...field} label="Task Type">
                      {[
                        "GST Filing",
                        "Audit",
                        "Tax Planning",
                        "Compliance",
                        "Consultation",
                      ].map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.taskType?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="dueDate"
                control={control}
                rules={{ required: "Due date is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Due Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.dueDate}
                    helperText={errors.dueDate?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="status"
                control={control}
                rules={{ required: "Status is required" }}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.status}>
                    <InputLabel>Status</InputLabel>
                    <Select {...field} label="Status">
                      {["Pending", "In Progress", "Completed"].map((status) => (
                        <MenuItem key={status} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.status?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="priority"
                control={control}
                rules={{ required: "Priority is required" }}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.priority}>
                    <InputLabel>Priority</InputLabel>
                    <Select {...field} label="Priority">
                      {["Low", "Medium", "High"].map((priority) => (
                        <MenuItem key={priority} value={priority}>
                          {priority}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.priority?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Description"
                    multiline
                    rows={3}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const CAClientTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterPriority, setFilterPriority] = useState("all");
  const { API_BASE_URL } = config;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const userId = useSelector((state) => state.auth.user?.id);
  

 

  const fetchTasks =   async () => {
    if (!userId) {
      showSnackbar("Missing user or company information", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/getTasks?userId=${userId}`
      );

      if (
        response.data &&
        response.data.status === "success" &&
        Array.isArray(response.data.data)
      ) {
        setTasks(response.data.data);

        if (response.data.data.length === 0) {
          showSnackbar("No tasks found", "info");
        }
      } else {
        setTasks([]);
        console.warn("Unexpected API response structure:", response.data);
        showSnackbar("Error loading tasks data", "error");
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      showSnackbar("Error fetching tasks", "error");
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTasks();
  }, [userId]);

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (data) => {
    if (!userId) {
      showSnackbar("User not authenticated", "error");
      return;
    }

    try {
      let response;

      if (currentTask?._id) {
        response = await axios.put(
          `${API_BASE_URL}/api/v1/updateTasks/${currentTask._id}`,
          {
            ...data,
            userId:userId,
          }
        );
      } else {
        response = await axios.post(`${API_BASE_URL}/api/v1/createTasks`, {
          ...data,
          userId:userId,
        });
      }

      if (response.data && response.data.status === "success") {
        showSnackbar(
          currentTask?._id
            ? "Task updated successfully"
            : "Task created successfully"
        );
        handleCloseDialog();
        fetchTasks();
      } else {
        showSnackbar(
          currentTask?._id ? "Error updating task" : "Error creating task",
          "error"
        );
      }
    } catch (error) {
      showSnackbar(
        error.response?.data?.message ||
          (currentTask?._id ? "Error updating task" : "Error creating task"),
        "error"
      );
      console.error("Error:", error);
    }
  };
  const handleDeleteTask = async (taskId) => {
    if (!window.confirm("Are you sure you want to delete this task?")) return;

    try {
      await axios.delete(`${API_BASE_URL}/api/v1/deleteTasks/${taskId}`);
      showSnackbar("Task deleted successfully");
      fetchTasks();
    } catch (error) {
      showSnackbar("Error deleting task", "error");
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentTask(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "warning";
      case "In Progress":
        return "primary";
      case "Completed":
        return "success";
      default:
        return "default";
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
        return "error";
      case "Medium":
        return "warning";
      case "Low":
        return "success";
      default:
        return "default";
    }
  };

  const filteredTasks = tasks.filter((task) => {
    const matchesStatus =
      filterStatus === "all" || task.status === filterStatus;
    const matchesPriority =
      filterPriority === "all" || task.priority === filterPriority;
    return matchesStatus && matchesPriority;
  });

  return (
    <Layout>
      <Container>
        <Typography variant="h4" gutterBottom>
          CA Client Tasks
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Priority</InputLabel>
              <Select
                value={filterPriority}
                onChange={(e) => setFilterPriority(e.target.value)}
                label="Priority"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="High">High</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenDialog(true)}
          sx={{ mb: 3 }}
        >
          Add Task
        </Button>

        <Paper>
          <TableContainer>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "2rem",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Client Name</TableCell>
                    <TableCell>Task Type</TableCell>
                    <TableCell>Due Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredTasks.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No tasks found
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredTasks.map((task) => (
                      <TableRow key={task._id}>
                        <TableCell>{task.clientName}</TableCell>
                        <TableCell>{task.taskType}</TableCell>
                        <TableCell>
                          {format(new Date(task.dueDate), "dd MMM yyyy")}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={task.status}
                            color={getStatusColor(task.status)}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={task.priority}
                            color={getPriorityColor(task.priority)}
                            size="small"
                          />
                        </TableCell>
                        <TableCell sx={{ maxWidth: 200 }}>
                          <Typography noWrap>{task.description}</Typography>
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Edit">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setCurrentTask(task);
                                setOpenDialog(true);
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteTask(task._id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Paper>

        <TaskForm
          open={openDialog}
          onClose={handleCloseDialog}
          currentTask={currentTask}
          onSubmit={handleSubmit}
        />

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </Layout>
  );
};

export default CAClientTasks;
